import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { AIRBNB_URL } from "@/data/property";

export default function StickyCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="lg:hidden fixed bottom-4 left-4 right-4 z-50"
        >
          <div className="glass rounded-full p-2 pl-5 flex items-center justify-between shadow-2xl shadow-[#0E2A47]/20">
            <div>
              <div className="font-display font-semibold text-[#0E2A47] text-sm leading-tight">Grandview Estate</div>
              <div className="text-xs text-[#0E2A47]/60 font-body">Sleeps 24 · Canyon Lake</div>
            </div>
            <a
              href={AIRBNB_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sticky-book-btn"
              className="group inline-flex items-center gap-1.5 rounded-full bg-[#1FB6C9] px-6 py-3 font-display font-medium text-white text-sm"
            >
              Book Now <ArrowRight size={16} className="cta-arrow" />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
